// components/WhyPMP.jsx
import React, { useState } from 'react';
import '../CSS/LandingWhyPMP.css';
import callImage from '../../assets/call.jpg';
import EligibilityModal from '../../components/EligibilityModal'; // Chemin corrigé

const PmpWhyPMP = ({ scrollToCalendar, openEligibilityModal }) => {
  const [showEligibilityModal, setShowEligibilityModal] = useState(false);

  const handleEligibilityComplete = (results) => {
    console.log('Résultats du questionnaire:', results);
    setShowEligibilityModal(false);
    
    // Rediriger vers l'inscription si recommandation PMP
    if (results.recommendation.certification === 'PMP') {
      scrollToCalendar();
    }
  };

  return (
    <section className="landing-why-pmp" id="pourquoi-pmp" style={{ marginBottom: "-80px" }}>
      <div className="landing-contenir">
        {/* TITRE ORIGINAL */}
        <h2 className="landing-section-title">Découvrez pourquoi le PMP change la donne</h2>
        <p className="landing-section-subtitle">
          Aujourd'hui, la performance des organisations dépend de leur capacité à livrer des projets à forte valeur ajoutée. Pourtant, malgré des milliers de milliards de dollars investis chaque année dans le monde, la majorité d'entre eux dépassent les délais, explosent les budgets ou ne délivrent pas la valeur attendue faute de pilotage efficace.
        </p>

        {/* TROIS BLOCS SUR LA MÊME LIGNE */}
        <div className="landing-three-blocks-container" style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '2rem',
          margin: '3rem 0'
        }}>
          {/* BLOC 1: LE PMP : LA CERTIFICATION QUI FAIT LA DIFFÉRENCE */}
          <div className="landing-pmp-certification-section" style={{
            flex: '1',
            minWidth: '300px',
            maxWidth: '100%',
            padding: '2.5rem',
            backgroundColor: '#0a3764',
            color: 'white',
            borderRadius: '0px',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '200px',
              height: '200px',
              backgroundColor: 'rgba(123, 185, 255, 0.1)',
              borderRadius: '50%'
            }}></div>

            <h3 className="landing-block-title">
              Le PMP : la certification qui fait la différence
            </h3>

            <p className="landing-block-text">
              La certification PMP<sup>®</sup> (Project Management Professional) est la référence mondiale en gestion de projet. Reconnue dans tous les secteurs et dans plus de 200 pays, elle atteste de votre capacité à conduire des projets complexes, à prendre les bonnes décisions et à délivrer des résultats mesurables.
            </p>
          </div>

          {/* BLOC 2: UNE COMPÉTENCE DE PLUS EN PLUS RECHERCHÉE - VERTE #94bf3e */}
          <div className="landing-skill-in-demand-section" style={{
            flex: '1',
            minWidth: '300px',
            maxWidth: '100%',
            padding: '2.5rem',
            backgroundColor: '#94bf3e',
            color: 'white',
            borderRadius: '0px',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <div style={{
              position: 'absolute',
              top: '-50px',
              left: '-50px',
              width: '200px',
              height: '200px',
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
              borderRadius: '50%'
            }}></div>

            <h3 className="landing-block-title">
              Une compétence de plus en plus recherchée
            </h3>

            <p className="landing-block-text">
              Selon les projections du PMI et de PwC, <strong className="landing-highlight-text">25 millions de nouveaux professionnels</strong> en management de projet seront nécessaires dans le monde d'ici 2030. Les organisations recherchent des profils certifiés, crédibles et immédiatement opérationnels.
            </p>
          </div>

          {/* BLOC 3: POURQUOI S'INSCRIRE MAINTENANT */}
          <div className="landing-why-now-section" style={{
            flex: '1',
            minWidth: '300px',
            maxWidth: '100%',
            padding: '2.5rem',
            backgroundColor: '#0a3764',
            color: 'white',
            borderRadius: '0px',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '200px',
              height: '200px',
              backgroundColor: 'rgba(123, 185, 255, 0.1)',
              borderRadius: '50%'
            }}></div>

            <h3 className="landing-block-title">
              Pourquoi vous inscrire maintenant ?
            </h3>

            <p className="landing-block-text" style={{ marginBottom: '1.5rem' }}>
              Dans un marché de plus en plus exigeant, le PMP ne vous rend pas simplement plus compétent, il vous rend visible, différenciant et incontournable. Vous prenez une longueur d'avance sur un marché en forte tension.
            </p>
          </div>
        </div>

      </div>
      
      {/* NOUVEAU BLOC: PASSEZ AU NIVEAU SUPÉRIEUR */}
      <div className="landing-next-level-section" style={{
        backgroundImage: `url(${callImage.src || callImage})`,
      }}>
        {/* Overlay sombre pour mieux lire le texte */}
        <div className="landing-next-level-overlay"></div>

        <h3 className="landing-next-level-title">
          Passez au niveau supérieur dès maintenant !
        </h3>

        <div className="landing-next-level-buttons">
          <button 
            className="landing-eligibility-btn"
            onClick={openEligibilityModal}
          >
            Vérifiez si vous êtes éligible
          </button>

          <button className="landing-join-btn" onClick={ scrollToCalendar }>
            <span className="landing-join-text-desktop">Rejoignez notre prochain parcours PMP</span>
            <span className="landing-join-text-mobile">Rejoignez notre prochain parcours</span>
          </button>
        </div>
      </div>

      {/* Modal d'éligibilité */}
      <EligibilityModal
        isOpen={showEligibilityModal}
        onClose={() => setShowEligibilityModal(false)}
        onComplete={handleEligibilityComplete}
      />

      <style jsx>{`
        /* Styles pour les blocs */
        .landing-block-title {
          font-size: 1.5rem;
          margin-bottom: 1.5rem;
          font-weight: 700;
          position: relative;
          z-index: 1;
          color: white;
        }
        
        .landing-block-text {
          font-size: 1.05rem;
          line-height: 1.6;
          position: relative;
          zIndex: 1;
          flex: 1;
          color: white;
        }
        
        .landing-highlight-text {
          color: #e8f5e0;
        }
        
        /* Styles pour les éléments de la liste */
        .landing-benefit-list-item {
          font-size: 1.05rem;
          line-height: 1.6;
          margin-bottom: 0.8rem;
          color: white;
        }
        
        /* Styles pour le bloc next-level - RÉDUIT */
        .landing-next-level-section {
          margin: 4rem auto 2rem;
          padding: 3rem;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          color: white;
          border-radius: 0px;
          text-align: center;
          position: relative;
          overflow: hidden;
          max-width: 1000px;
        }
        
        .landing-next-level-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.4);
          z-index: 0;
        }
        
        .landing-next-level-title {
          font-size: 2rem;
          margin-bottom: 1.5rem;
          font-weight: 700;
          position: relative;
          zIndex: 1;
          color: white;
        }
        
        .landing-next-level-buttons {
          position: relative;
          zIndex: 1;
          margin-top: 2rem;
          display: flex;
          justify-content: center;
          gap: 2rem;
          flex-wrap: wrap;
        }
        
        .landing-eligibility-btn, .landing-join-btn {
          padding: 1rem 2.5rem;
          font-size: 1.1rem;
          font-weight: 600;
          border: none;
          border-radius: 0px;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 250px;
        }
        
        .landing-eligibility-btn {
          background-color: #94bf3e;
          color: white;
          border: 2px solid #94bf3e;
        }
        
        .landing-eligibility-btn:hover {
          background-color: #94bf3e;
          border-color: #f0f0f0;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(148, 191, 62, 0.3);
        }
        
        .landing-join-btn {
          background-color: #0a3764;
          color: white;
          border: 2px solid #0a3764;
        }
        
        .landing-join-btn:hover {
          background-color: #09407e;
          border-color: #09407e;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(10, 55, 100, 0.3);
        }
        
        /* Masquer le texte mobile par défaut */
        .landing-join-text-mobile {
          display: none;
        }
        
        /* Afficher le texte desktop par défaut */
        .landing-join-text-desktop {
          display: inline;
        }
        
        /* RESPONSIVE POUR LES TROIS BLOCS */
        @media (max-width: 1024px) {
          .landing-three-blocks-container {
            gap: 1.5rem;
            margin: 2.5rem 0;
          }
          
          .landing-pmp-certification-section,
          .landing-skill-in-demand-section,
          .landing-why-now-section {
            padding: 2rem;
            min-width: calc(50% - 1rem);
          }
          
          .landing-block-title {
            font-size: 1.3rem;
            margin-bottom: 1.2rem;
          }
          
          .landing-block-text {
            font-size: 1rem;
          }
          
          .landing-next-level-section {
            padding: 2.5rem;
            max-width: 900px;
          }
          
          .landing-next-level-title {
            font-size: 1.8rem;
          }
        }
        
        /* RESPONSIVE MOBILE (≤768px) */
        @media (max-width: 768px) {
          .landing-three-blocks-container {
            gap: 1rem;
            margin: 2rem 0;
          }
          
          .landing-pmp-certification-section,
          .landing-skill-in-demand-section,
          .landing-why-now-section {
            min-width: 100%;
            padding: 1.8rem;
          }
          
          .landing-block-title {
            font-size: 1.2rem;
            margin-bottom: 1rem;
          }
          
          .landing-block-text {
            font-size: 0.95rem;
            line-height: 1.5;
          }
          
          .landing-benefit-list-item {
            font-size: 0.95rem;
            line-height: 1.5;
            margin-bottom: 0.7rem;
          }
          
          .landing-next-level-section {
            padding: 2rem 1.5rem;
            margin: 3rem auto 1.5rem;
            max-width: 100%;
          }
          
          .landing-next-level-title {
            font-size: 1.5rem;
            margin-bottom: 1rem;
            line-height: 1.4;
          }
          
          .landing-next-level-buttons {
            flex-direction: row;
            gap: 1rem;
            align-items: center;
            justify-content: center;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            width: auto;
            max-width: none;
            padding: 0.9rem 1.5rem;
            font-size: 1rem;
            min-width: auto;
            flex: 1;
          }
          
          /* Cacher "PMP" sur mobile - changer le texte du bouton */
          .landing-join-text-desktop {
            display: none;
          }
          
          .landing-join-text-mobile {
            display: inline;
          }
        }
        
        /* RESPONSIVE PETIT MOBILE (≤480px) */
        @media (max-width: 480px) {
          .landing-three-blocks-container {
            gap: 0.8rem;
            margin: 1.5rem 0;
          }
          
          .landing-pmp-certification-section,
          .landing-skill-in-demand-section,
          .landing-why-now-section {
            padding: 1.5rem;
          }
          
          .landing-block-title {
            font-size: 1.1rem;
            margin-bottom: 0.8rem;
          }
          
          .landing-block-text {
            font-size: 0.9rem;
            line-height: 1.4;
          }
          
          .landing-benefit-list-item {
            font-size: 0.9rem;
            line-height: 1.4;
            margin-bottom: 0.6rem;
          }
          
          .landing-next-level-section {
            padding: 1.5rem 1rem;
          }
          
          .landing-next-level-title {
            font-size: 1.3rem;
            line-height: 1.4;
          }
          
          .landing-next-level-buttons {
            flex-direction: row;
            gap: 0.8rem;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            font-size: 0.9rem;
            padding: 0.8rem 1rem;
            flex: 1;
            min-width: 120px;
          }
          
          /* Cacher "PMP" sur petit mobile */
          .landing-join-text-desktop {
            display: none;
          }
          
          .landing-join-text-mobile {
            display: inline;
          }
        }
        
        /* RESPONSIVE TRÈS PETIT MOBILE (≤360px) */
        @media (max-width: 360px) {
          .landing-pmp-certification-section,
          .landing-skill-in-demand-section,
          .landing-why-now-section {
            padding: 1.2rem;
          }
          
          .landing-block-title {
            font-size: 1rem;
          }
          
          .landing-block-text {
            font-size: 0.85rem;
          }
          
          .landing-benefit-list-item {
            font-size: 0.85rem;
            line-height: 1.4;
          }
          
          .landing-next-level-section {
            padding: 1.2rem 0.8rem;
          }
          
          .landing-next-level-title {
            font-size: 1.2rem;
          }
          
          .landing-next-level-buttons {
            flex-direction: row;
            gap: 0.5rem;
          }
          
          .landing-eligibility-btn, .landing-join-btn {
            font-size: 0.8rem;
            padding: 0.7rem 0.8rem;
            min-width: 110px;
          }
          
          /* Cacher "PMP" sur très petit mobile */
          .landing-join-text-desktop {
            display: none;
          }
          
          .landing-join-text-mobile {
            display: inline;
          }
        }
        
        /* Pour les écrans très larges (> 1200px) */
        @media (min-width: 1200px) {
          .landing-next-level-section {
            max-width: 1000px;
          }
          
          .landing-next-level-title {
            font-size: 2.2rem;
          }
        }
      `}</style>
    </section>
  );
};

export default PmpWhyPMP;